import { jsx as o, jsxs as c } from "react/jsx-runtime";
import C from "clsx";
import { useState as u } from "react";
import r from "./Code.module.css.js";
import { Label as b } from "../Label/Label.js";
import { Flex as g } from "../Flex/Flex.js";
import { IconButton as x } from "../IconButton/IconButton.js";
import { Clipboard as w } from "../../foundations/icons/Clipboard.js";
const W = ({
  labelText: e,
  multiline: n = !1,
  clipboard: m = !1,
  children: t,
  ...i
}) => {
  const [d, a] = u("Copy"), l = t ? t.toString() : "", f = () => {
    typeof t == "string" && navigator.clipboard.writeText(l).then(() => {
      a("Copied"), setTimeout(() => {
        a("Copy");
      }, 3e3);
    });
  }, p = !!navigator?.clipboard && m, s = n ? /* @__PURE__ */ o("pre", { className: r.code, ...i, children: /* @__PURE__ */ o("code", { children: t }) }) : /* @__PURE__ */ o("code", { className: C(r.code, r.noWrap), ...i, children: t });
  return e || p ? /* @__PURE__ */ c("div", { className: r.fullWidth, children: [
    e && /* @__PURE__ */ o(b, { text: e }),
    /* @__PURE__ */ c(g, { direction: "row", align: "center", wrap: "nowrap", gap: 1, children: [
      s,
      p && /* @__PURE__ */ o(x, { onClick: f, ariaLabel: `${d} to clipboard`, children: /* @__PURE__ */ o(w, {}) })
    ] })
  ] }) : s;
};
export {
  W as Code
};
//# sourceMappingURL=Code.js.map
